import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

export default class extends React.Component {
  componentDidMount() {
    setDocumentTitle('Welcome')
  }
  render() {
    return (<div className="img750">
      <div className="policy">
        <h1>Welcome to App</h1>
        We are in Beta version. If you have any questions, please search user 10000 and leave your suggestions.
        </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/beta/index.js